/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityVulnerabilitiesCount
 */
export interface MonitEntityVulnerabilitiesCount {
    /**
     * 
     * @type {number}
     * @memberof MonitEntityVulnerabilitiesCount
     */
    critical?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityVulnerabilitiesCount
     */
    high?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityVulnerabilitiesCount
     */
    medium?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityVulnerabilitiesCount
     */
    low?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityVulnerabilitiesCount
     */
    info?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityVulnerabilitiesCount
     */
    count?: number;
}

/**
 * Check if a given object implements the MonitEntityVulnerabilitiesCount interface.
 */
export function instanceOfMonitEntityVulnerabilitiesCount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityVulnerabilitiesCountFromJSON(json: any): MonitEntityVulnerabilitiesCount {
    return MonitEntityVulnerabilitiesCountFromJSONTyped(json, false);
}

export function MonitEntityVulnerabilitiesCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityVulnerabilitiesCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'critical': !exists(json, 'critical') ? undefined : json['critical'],
        'high': !exists(json, 'high') ? undefined : json['high'],
        'medium': !exists(json, 'medium') ? undefined : json['medium'],
        'low': !exists(json, 'low') ? undefined : json['low'],
        'info': !exists(json, 'info') ? undefined : json['info'],
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function MonitEntityVulnerabilitiesCountToJSON(value?: MonitEntityVulnerabilitiesCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'critical': value.critical,
        'high': value.high,
        'medium': value.medium,
        'low': value.low,
        'info': value.info,
        'count': value.count,
    };
}

